import React, { useEffect, useState } from 'react'
import request from 'meinian-package/src/utils/request'
import { cloneDeep } from 'lodash'
import Cascade from '../cascade'
import styles from './index.module.less'

const convert = (result) => {
  const arr = cloneDeep(result)
  const loop = (nodeArr, parent, level = 0, root = {}) => {
    level += 1
    nodeArr.forEach((node) => {
      node.label = node.name
      node.value = node.name
      node.parent = parent
      if (node.children && node.children.length) {
        loop(node.children, node, level, root)
      }
    })
  }
  loop(arr)
  return arr
}

export default ({
  value,
  gender,
  onChange,
  shopStatus = null,
  label = '品类：',
  placeholder = '不限',
  displayStyle = null,
  placement = 'bottomLeft',
  overlayStyle = {}
}) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchData()
  }, [shopStatus])

  const fetchData = () => {
    request.get('/zhikuan/common/list-all-category', { params: { shopStatus } }).then(res => {
      setOptions(convert(res.children))
    })
  }

  const getText = (item) => {
    let text = item.value
    if (item?.parent) {
      const t = getText(item.parent)
      text = t
    }
    return text
  }
  const _onChange = (val, cur) => {
    const root = getText(cur)
    onChange(val, root)
  }
  return <div className={styles['gender-category-wrap']}>
    {
      label && <div>{label}</div>
    }
    <Cascade
      overlayStyle={{ padding: '0px', ...overlayStyle }}
      listClassName={styles['mn-category']}
      value={value}
      gender={gender}
      onChange={(val, cur) => _onChange(val, cur)}
      placeholder={placeholder}
      trigger="click"
      options={options}
      displayStyle={displayStyle}
      placement={placement}
    />
  </div>
}
